var _path, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSpelling16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.69224 11.384C4.52636 11.8939 4.0511 12.239 3.51489 12.239V12.239C2.66427 12.239 2.06701 11.401 2.34458 10.5969L5.27794 2.09973C5.58723 1.20381 6.43181 0.602661 7.37962 0.602661V0.602661C8.32778 0.602661 9.1726 1.20426 9.48161 2.10065L12.4106 10.5973C12.6878 11.4013 12.0905 12.239 11.24 12.239V12.239C10.7035 12.239 10.228 11.8935 10.0623 11.3832L7.43948 3.305C7.43111 3.27921 7.40708 3.26175 7.37997 3.26175V3.26175C7.35287 3.26175 7.32885 3.2792 7.32047 3.30496L4.69224 11.384ZM4.2493 8.62539C4.2493 8.09507 4.67921 7.66516 5.20953 7.66516H9.51635C10.0467 7.66516 10.4766 8.09507 10.4766 8.62539V8.62539C10.4766 9.15571 10.0467 9.58562 9.51635 9.58562H5.20953C4.67921 9.58562 4.2493 9.15571 4.2493 8.62539V8.62539Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14.825,
    width: 1.77778,
    height: 1.77778,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.55554,
    y: 14.825,
    width: 1.77778,
    height: 1.77778,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.11108,
    y: 14.825,
    width: 1.77778,
    height: 1.77778,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6667,
    y: 14.825,
    width: 1.77778,
    height: 1.77778,
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2223,
    y: 14.825,
    width: 1.77778,
    height: 1.77778,
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpelling16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;